import JourneyStatusLabel from "@/components/domains/JourneyStatusLabel";
import type { JourneyRow as JourneyRowData } from "@/types";

type Props = {
  journey: JourneyRowData;
  auditing: boolean;
  canStartAudits: boolean;
  auditBusy?: boolean;
  onAudit: (journey: JourneyRowData) => void;
  onWatch?: (journey: JourneyRowData) => void;
};

export default function JourneyRow({ journey, auditing, canStartAudits, auditBusy = false, onAudit, onWatch }: Props) {
  return (
    <div
      data-testid="journey-row"
      className="flex flex-col gap-2 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4"
    >
      <div className="min-w-0">
        <p className="font-medium break-words text-gray-900">{journey.title}</p>
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 sm:shrink-0 sm:justify-end">
        <JourneyStatusLabel journey={journey} onWatch={onWatch} />
        {canStartAudits ? (
          <button
            type="button"
            className="cursor-pointer text-sm font-medium text-primary hover:underline disabled:cursor-not-allowed disabled:opacity-50 disabled:no-underline"
            disabled={auditBusy}
            onClick={() => onAudit(journey)}
          >
            {auditing ? "Starting…" : "Audit"}
          </button>
        ) : null}
      </div>
    </div>
  );
}
